import React from 'react';

import styles from './DiscoverSong.module.scss';
import {LikeCountButton} from '../../../components';
import {Button} from '../../../../../components';
import {useObsidianContext} from '../../../../../context/ObsidianProvider';
import {CatalogSong, Platform} from '../../../../../types';

interface Props {
  song: CatalogSong;
}

export default function DiscoverSong({song}: Props) {
  //const className = classNames(styles.Button, shadow && styles.shadow);
  const {obsidian} = useObsidianContext();
  const {name, artwork, artistName, liked, likes} = song;

  const image = artwork.smallUrl;

  return (
    <div className={styles.DiscoverSong}>
      <div className={styles.AlbumArt}>
        <button
          className={styles.ThumbnailButton}
          onClick={() => obsidian.play(song, Platform.AppleMusic)}
        >
          <img alt="cover" src={image} />
          <div className={styles.ImageOverlay} />
        </button>
      </div>
      <div className={styles.SongDetails}>
        <h3 className={styles.SongDescription}>
          <span className={styles.Name}>{`${name}, `}</span>
          {artistName}
        </h3>
        <div className={styles.ButtonContainer}>
          <Button onClick={() => {}}>View Album</Button>
          <LikeCountButton likes={likes} liked={liked} />
        </div>
      </div>
    </div>
  );
}
